"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Article_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Article"));
var MediaManagerImage_1 = require("@sportnet/ui/lib/MediaManagerImage");
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var polished_1 = require("polished");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importStar(require("../../../../theme/styled-components"));
var utilities_2 = require("../../../../view/utilities");
var Slider_1 = tslib_1.__importDefault(require("../../../components/Slider"));
var Paging_1 = require("./Paging");
var linkClass = 'article-full-rotation-link';
var StyledDots = styled_components_1["default"](Paging_1.Dots)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding-top: ", " !important;\n"], ["\n  padding-top: ", " !important;\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.em(theme.grid.gutterWidth);
});
var StyledSlider = styled_components_1["default"](Slider_1["default"])(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  .", " {\n    padding: 0 ", ";\n  }\n"], ["\n  .", " {\n    padding: 0 ", ";\n  }\n"])), linkClass, function (_a) {
    var theme = _a.theme;
    return polished_1.em(theme.grid.gutterWidth / 2);
});
var FullRotation = function (_a) {
    var className = _a.className, renderLink = _a.renderLink, items = _a.items, theme = _a.theme;
    var sliderSettings = {
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        swipeToSlide: true,
        arrows: false,
        centerPadding: theme.grid.gutterWidth * 2 + "px",
        slide: "a." + linkClass,
        autoplay: true,
        appendDots: function (dots) {
            return react_1["default"].createElement(StyledDots, null, dots);
        },
        customPaging: function () { return react_1["default"].createElement(Paging_1.Dot, null); },
        responsive: [
            {
                breakpoint: utilities_1.mediaSizes.l,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: utilities_1.mediaSizes.s,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: utilities_1.mediaSizes.xs,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    };
    return (react_1["default"].createElement(StyledSlider, tslib_1.__assign({ className: className || 'article-full-rotation-slider' }, sliderSettings), items.map(function (item) {
        return renderLink({
            type: utilities_2.WIDGET_LINK_TYPE.ARTICLE_DETAIL,
            payload: item,
            linkProps: {
                key: item._id,
                className: linkClass,
                draggable: false,
                children: (react_1["default"].createElement(Article_1["default"], { title: item.name, subtitle: utilities_2.getArticleMeta(item), imgSrc: MediaManagerImage_1.getMediaManagerUrl(item.picture, 429, 322, 'media') }))
            }
        });
    })));
};
exports["default"] = styled_components_1.withTheme(FullRotation);
var templateObject_1, templateObject_2;
